import type { ImageProps } from '@unpic/react'
import { Image as UnpicImage } from '@unpic/react'

export const Image = (props: ImageProps) => {
  return <UnpicImage {...props} />
}
